const StatsIcon = ({ className, ...props }) => (
    <svg
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        width="1em"
        height="1em"
        {...props}
    >
        <path
            d="M1.33203 1.33203L1.33203 14.6654"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.3346 6.5L1.33464 6.5L1.33464 9.5L13.3346 9.5C14.068 9.5 14.668 9.2 14.668 8.3L14.668 7.7C14.668 6.8 14.068 6.5 13.3346 6.5Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33464 2L1.33464 2L1.33464 4.66667L9.33464 4.66667C10.068 4.66667 10.668 4.4 10.668 3.6L10.668 3.06667C10.668 2.26667 10.068 2 9.33464 2Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.9987 11.332L1.33203 11.332L1.33203 13.9987L5.9987 13.9987C6.73203 13.9987 7.33203 13.732 7.33203 12.932L7.33203 12.3987C7.33203 11.5987 6.73203 11.332 5.9987 11.332Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default StatsIcon;